//================================================================
//  Component: Tab View SidePane SidePane
//================================================================

//  Purpose: Simple way to build a Tab View SidePane SidePane for content without route navigation

//  Properties:
//    - defaultView = {A string, default view for the tabular view}
//    - oneTitle = {A string, title of the tab}
//    - oneContent = {HTML, pass in the content}
//    - twoTitle = {A string, title of the tab}
//    - twoContent = {HTML, pass in the content}
//    - threeTitle = {A string, title of the tab}
//    - threeContent = {HTML, pass in the content}
//    - fourTitle = {A string, title of the tab}
//    - fourContent = {HTML, pass in the content}
//    - fiveTitle = {A string, title of the tab}
//    - fiveContent = {HTML, pass in the content}
//    - sixTitle = {A string, title of the tab}
//    - sixContent = {HTML, pass in the content}
//    - sevenTitle = {A string, title of the tab}
//    - sevenContent = {HTML, pass in the content}

//  Example:
//    <TabViewSidePane
//      defaultView={1}
//      oneTitle={"Overview"}
//      oneContent={<div>Overview content</div>}
//      twoTitle={"Pricing"}
//      twoContent={<div>Pricing content</div>}
//      threeTitle={"Support"}
//      threeContent={<div>Support content</div>}
//    ></TabViewSidePane>    

//================================================================

//Libraries
import React, { useState } from 'react';

export default function TabViewSidePane({
    defaultView,
    oneTitle,
    oneContent,
    oneCount,
    twoTitle,
    twoContent,
    twoCount,
    threeTitle,
    threeContent,
    threeCount,
    fourTitle,
    fourContent,
    fourCount,
    fiveTitle,
    fiveContent,
    fiveCount,
    sixTitle,
    sixContent,
    sixCount,
    sevenTitle,
    sevenContent,
    sevenCount
}) {

    //------------------------------------------------------
    //  useStates
    //------------------------------------------------------

    //Visibilty of content > depends on click event for each tab
    const [activeTab, setActiveTab] = useState(defaultView);

    //------------------------------------------------------
    //  Functions
    //------------------------------------------------------

    // When a tab is clicked --> Update active tab
    function handleTabClick(id) {
        setActiveTab(id);
    };

    // Disable the tab when no content is passed down
    function hideTab(title) {
        // No content passed in --> hide section
        if (title === undefined) return true;

        return false;
    };

    // Toggles between visible/hidden content
    function showContent(id) {
        if (activeTab === id) return true;
        return false;
    };

    // Toggles the style when the tab is selected
    function navStyle(id) {
        //Nav item style
        if (activeTab === id) {
            return 'flex gap-2 cursor-pointer font-medium border-b-solid border-b-[var(--teal)] border-b-2 px-[10px] py-[12px]'; // Selected Style
        } else {
            return 'flex gap-2 cursor-pointer px-[10px] py-[12px]'; // Default Style
        }
    };

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <div className='w-full h-full flex flex-col'>

            {/* Tabs - Sticky Header */}
            <div
                hidden={hideTab(oneTitle)}
                className='flex flex-row gap-3 border-[#D8D8D8] border-b mt-2 px-4 h-[50px] sticky top-0 bg-white z-10'
            >
                <div className={navStyle(1)}>
                    <div hidden={hideTab(oneTitle)} onClick={() => handleTabClick(1)} style={{ fontSize: '16px' }}>{oneTitle}</div>
                    {
                        oneCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{oneCount}</div>
                    }
                </div>
                <div className={navStyle(2)}>
                    <div hidden={hideTab(twoTitle)} onClick={() => handleTabClick(2)} style={{ fontSize: '16px' }}>{twoTitle}</div>
                    {
                        twoCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{twoCount}</div>
                    }
                </div>
                <div className={navStyle(3)}>
                    <div hidden={hideTab(threeTitle)}  onClick={() => handleTabClick(3)} style={{ fontSize: '16px' }}>{threeTitle}</div>
                    {
                        threeCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{threeCount}</div>
                    }
                </div>
                <div className={navStyle(4)}>
                    <div hidden={hideTab(fourTitle)} onClick={() => handleTabClick(4)} style={{ fontSize: '16px' }}>{fourTitle}</div>
                    {
                        fourCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{fourCount}</div>
                    }
                </div>
                <div className={navStyle(5)}>
                    <div hidden={hideTab(fiveTitle)} onClick={() => handleTabClick(5)} style={{ fontSize: '16px' }}>{fiveTitle}</div>
                    {
                        fiveCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{fiveCount}</div>
                    }
                </div>
                <div className={navStyle(6)}>
                    <div hidden={hideTab(sixTitle)} onClick={() => handleTabClick(6)} style={{ fontSize: '16px' }}>{sixTitle}</div>
                    {
                        sixCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{sixCount}</div>
                    }
                </div>
                <div className={navStyle(7)}>
                    <div hidden={hideTab(sevenTitle)} onClick={() => handleTabClick(7)} style={{ fontSize: '16px' }}>{sevenTitle}</div>
                    {
                        sevenCount > 0 && <div className='flex items-center justify-center w-6 h-6 bg-[#000] text-white rounded-full text-xs font-bold'>{sevenCount}</div>
                    }
                </div>
            </div>

            {/* Content - Scrollable Area */}
            <div className='mx-[0%] py-[20px] px-[20px] overflow-y-auto flex-grow shadow-inner'>
                <>
                    {
                        showContent(1) === true &&
                        oneContent
                    }
                </>

                <>
                    {
                        showContent(2) === true &&
                        twoContent
                    }
                </>

                <>
                    {
                        showContent(3) === true &&
                        threeContent
                    }
                </>

                <>
                    {
                        showContent(4) === true &&
                        fourContent
                    }
                </>

                <>
                    {
                        showContent(5) === true &&
                        fiveContent
                    }
                </>

                <>
                    {
                        showContent(6) === true &&
                        sixContent
                    }
                </>

                <>
                    {
                        showContent(7) === true &&
                        sevenContent
                    }
                </>
            </div>

        </div>
    )
}